/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { reportsOverviewPageEntryPoint as reportsOverviewPageEntry } from '@jira/software__reports-overview-page/src/reportsOverviewPageEntryPoint.entrypoint.tsx';
import { getRapidboardResources } from '@jira/router-resources__classic-projects/src/getRapidboardResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { rapidboardUserReportsOverviewRoute } from '@jira/router-routes__classic-projects-routes/src/rapidboardUserReportsOverviewRoute.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import {
	getNavigationResources,
	getUserBoardNavigationResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import type { Route } from '@atlassian/react-resource-router';

const reportsOverviewPageEntryPoint = createPageEntryPoint({
	main: reportsOverviewPageEntry,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const rapidboardUserReportsOverviewRouteEntry: Route = createEntry(
	rapidboardUserReportsOverviewRoute,
	() => ({
		group: 'classic-software',

		entryPoint() {
			return reportsOverviewPageEntryPoint;
		},

		layout: genericProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [
			...getNavigationResources(),
			incidentExperimentTraitResource,
			...getUserBoardNavigationResources(),
			...getRapidboardResources(),
		],

		ufoName: 'reports-overview',
		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
